module.exports = __webpack_public_path__ + "img/Anhänger_MzAB.e3d3e629.svg";